import { render, staticRenderFns } from "./purchas-invoice.vue?vue&type=template&id=43d88508&"
import script from "./purchas-invoice.vue?vue&type=script&lang=js&"
export * from "./purchas-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports